module.exports = __webpack_public_path__ + "img/iphone-network.50a46ed.png";